webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(21);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Navbar = __webpack_require__(4);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _router = __webpack_require__(5);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.Vue = _vue2.default;
	
	new _vue2.default({
	  router: _router2.default,
	  components: {
	    'navbar': _Navbar2.default
	  },
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": "3",
			"type": "content",
			"dir": "an-article-3",
			"title": "An article 3",
			"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br/><br/>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br/><br/>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"thumb": "test",
			"poster": "header",
			"sharetitle": "",
			"sharedescription": "",
			"sharemessage": "",
			"shareurl": "",
			"shareimg": "",
			"hashtags": "",
			"bgcolor": "#8493ca",
			"color": "#333333",
			"date": "June 11, 2017"
		},
		{
			"id": "2",
			"type": "link",
			"dir": "an-article-2",
			"title": "This is another article",
			"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"thumb": "test",
			"poster": "header",
			"image": [],
			"sharetitle": "",
			"sharedescription": "",
			"sharemessage": "",
			"shareurl": "",
			"shareimg": "",
			"hashtags": "",
			"bgcolor": "#8493ca",
			"color": "#333333",
			"date": "June 09, 2017",
			"source": "Lorem ipsum [source]",
			"url": "http://www.google.co.uk/"
		},
		{
			"id": "1",
			"type": "content",
			"dir": "an-article-1",
			"title": "An article 1",
			"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"thumb": "test",
			"poster": "header",
			"sharetitle": "",
			"sharedescription": "",
			"sharemessage": "",
			"shareurl": "",
			"shareimg": "",
			"hashtags": "",
			"bgcolor": "#8493ca",
			"color": "#333333",
			"date": "June 04, 2017"
		},
		{
			"id": "0",
			"type": "content",
			"dir": "an-article-0",
			"title": "An article 0",
			"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"thumb": "test",
			"poster": "header",
			"sharetitle": "",
			"sharedescription": "",
			"sharemessage": "",
			"shareurl": "",
			"shareimg": "",
			"hashtags": "",
			"bgcolor": "#8493ca",
			"color": "#333333",
			"date": "June 01, 2017"
		}
	];

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(20)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(10),
	  /* template */
	  __webpack_require__(34),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(37);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(36);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _main = __webpack_require__(27);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _dashboard = __webpack_require__(26);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _SingleArticle = __webpack_require__(25);
	
	var _SingleArticle2 = _interopRequireDefault(_SingleArticle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.headers.common['Access-Control-Allow-Origin'] = 'http://s3.ralphandco.com';
	
	var routes = [{ path: '/', component: _main2.default }, { path: '/dashboard', component: _dashboard2.default }, { path: '/article', component: _SingleArticle2.default }, { name: 'single-project', path: '/article/:id', component: _SingleArticle2.default, props: true }, { path: '/article/:*', component: _dashboard2.default }];
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes,
	  linkActiveClass: 'is-active'
	});

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footbar = __webpack_require__(24);
	
	var _Footbar2 = _interopRequireDefault(_Footbar);
	
	var _Navbar = __webpack_require__(4);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: { footbar: _Footbar2.default, navbar: _Navbar2.default }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['project'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {},
	  created: function created() {},
	
	  computed: {}
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['project'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    shareFB: function shareFB() {
	      window.FB.ui({
	        method: 'share',
	        display: 'popup',
	        title: this.project.sharetitle,
	        name: this.project.sharetitle,
	        link: this.project.sharetitle,
	        picture: this.project.shareimg,
	        caption: this.project.shareurl,
	        description: this.project.sharedescription,
	        href: this.project.shareurl
	      }, function (response) {
	        console.log('FB callback');
	      });
	    }
	  },
	  mounted: function mounted() {},
	  created: function created() {},
	
	  computed: {}
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'footbar'
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'navbar'
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(3);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _ArticleUsername = __webpack_require__(22);
	
	var _ArticleUsername2 = _interopRequireDefault(_ArticleUsername);
	
	var _ArticleView = __webpack_require__(23);
	
	var _ArticleView2 = _interopRequireDefault(_ArticleView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'projects',
	  props: ['project'],
	  data: function data() {
	    return {
	      projects: [],
	      thisproject: {}
	    };
	  },
	  methods: {
	    loadProjects: function loadProjects() {
	      this.projects = _content2.default;
	    },
	    fetchData: function fetchData() {
	      this.url = this.$route.params.id;
	    },
	
	    getProject: function getProject() {
	      for (var i = 0; this.projects.length > i; i++) {
	        if (this.projects[i].dir === this.url) return this.projects[i];
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.loadProjects();
	    this.fetchData();
	
	    if (this.project === undefined) {
	      this.thisproject = this.getProject();
	    } else {
	      this.thisproject = this.project;
	    }
	
	    setTimeout(function () {
	      window.scrollTo(0, 0);
	    }, 600);
	  },
	  components: { ArticleView: _ArticleView2.default, ArticleUsername: _ArticleUsername2.default }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dashboard'
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _content = __webpack_require__(3);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('task-list', {
	  props: ['project', 'index'],
	  data: function data() {
	    return {
	      dir: this.project.dir
	    };
	  },
	
	  template: '<router-link class="is-tab" :to="{ name: \'single-project\', params: { id: project.dir, project: project, title: project.title }}">\n     \n     <div v-if="project.type == \'content\'" class="article-holder article-type-content item">\n      <img :src="\'../static/img/site/\'+project.thumb+\'.jpg\'" />\n      <div class="article-square-info">\n        <h3 v-html="project.title"></h3>\n        <p v-html="project.abstract"></p>\n        <div class="article-holder-date" v-html="project.date"></div>\n      </div>  \n    </div>\n\n    <div v-if="project.type == \'link\'" class="article-holder article-type-link item">\n      <div class="article-link-info">\n        <h3 v-html="project.abstract"></h3>\n        <p v-html="project.source"></p>\n        <div class="article-holder-date" v-html="project.date"></div>\n      </div>  \n    </div>\n\n  </router-link>',
	  computed: {
	    classIndex: function classIndex() {
	      return Math.floor(Math.random() * 3);
	    },
	    checkUrl: function checkUrl() {
	      var val = false;
	      if (this.url === this.dir || this.url === undefined) val = true;
	      return val;
	    },
	    showProject: function showProject() {
	      var val = false;
	      if (this.url === this.dir) val = true;
	      return val;
	    }
	  }
	});
	
	exports.default = {
	  name: 'main',
	  data: function data() {
	    return {
	      projects: [],
	      url: ''
	    };
	  },
	  methods: {
	    loadProjects: function loadProjects() {
	      this.projects = _content2.default;
	    }
	  },
	  mounted: function mounted() {
	    this.loadProjects();
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 17 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(14)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(28),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(15)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(29),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(18)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(32),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(17)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(31),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(19)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(33),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(12),
	  /* template */
	  __webpack_require__(35),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(16)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(13),
	  /* template */
	  __webpack_require__(30),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('navbar'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('footbar')], 1)
	},staticRenderFns: []}

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Welcome to Ralph PR John Smith")]), _vm._v(" "), _c('hr')])
	}]}

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-medium project-header"
	  }, [_c('img', {
	    staticClass: "project-header-img-desktop",
	    attrs: {
	      "src": '../../static/img/common/home_poster.jpg'
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "content-inner"
	  }, _vm._l((_vm.projects), function(project, index) {
	    return _c('task-list', {
	      attrs: {
	        "project": project,
	        "index": index
	      }
	    })
	  }))])])
	},staticRenderFns: []}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "content-inner"
	  }, [_c('p', [_c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("www.ralphandco.com |")]), _vm._v(" @ralphcreative")]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("Ralph LONDON |")]), _vm._v(" 27-33 Bethnal Green Road, E1 6LA "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" +44 (0)20 3006 6730 "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" london@ralphandco.com\n      "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("Ralph NEW YORK |")]), _vm._v(" 100 Lafayette St, Unit 401, NY, 10013 "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" +1 (212) 226 2089 "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" newyork@ralphandco.com\n      "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("Ralph LOS ANGELES |")]), _vm._v(" 100 Lafayette St, Unit 401, NY, 10013 "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" +1 (212) 226 2089 "), _c('span', {
	    staticClass: "span-pink"
	  }, [_vm._v("|")]), _vm._v(" la@ralphandco.com")]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social"
	  }, [_c('div', {
	    staticClass: "footer-logo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/ralph_logo.svg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/social_linkedin.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/social_twitter.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/social_facebook.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/social_instagram.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-social-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/social_vimeo.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "footer-band"
	  }, [_c('div', {
	    staticClass: "footer-band-color ralph-pink"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-band-color ralph-blue"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-band-color ralph-orange"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-band-color ralph-green"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-band-color ralph-yellow"
	  })])])
	}]}

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "article-body"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.project.date)
	    }
	  }), _vm._v(" "), _c('h1', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.project.title)
	    }
	  }), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.project.description)
	    }
	  }), _vm._v(" "), _c('hr')])])
	},staticRenderFns: []}

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "hero is-medium article-header",
	    style: ({
	      backgroundColor: _vm.thisproject.bgcolor
	    })
	  }, [_c('img', {
	    staticClass: "article-header-img-desktop",
	    attrs: {
	      "src": '../../static/img/site/' + _vm.thisproject.poster + '.jpg'
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "article-inner"
	  }, [_c('article-username', {
	    attrs: {
	      "project": _vm.thisproject
	    }
	  }), _vm._v(" "), _c('article-view', {
	    attrs: {
	      "project": _vm.thisproject
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "header"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "header-title"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../static/img/common/logo_header.svg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	      "alt": "Ralph Creative PR"
	    }
	  })])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "shadow"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "navbar"
	    }
	  }, [_c('ul', [_c('li', [_vm._v("WEBSITE")]), _vm._v(" "), _c('li', [_vm._v("ARCHIVE")]), _vm._v(" "), _c('li', [_vm._v("CONTACT")])])])
	}]}

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "dashboard"
	    }
	  }, [_vm._v("\n  Dashboard content will go here\n")])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.681bf5e8faef4f83cb72.js